var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenEye = function SvgOpenEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.66699C4.4 3.33366 11.6 3.33366 14 8.66699",
    stroke: "#4D5559",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.334C7.73736 11.334 7.47728 11.2823 7.23463 11.1817C6.99198 11.0812 6.7715 10.9339 6.58579 10.7482C6.40007 10.5625 6.25275 10.342 6.15224 10.0994C6.05173 9.8567 6 9.59663 6 9.33398C6 9.07134 6.05173 8.81127 6.15224 8.56862C6.25275 8.32597 6.40007 8.10549 6.58579 7.91977C6.7715 7.73405 6.99198 7.58673 7.23463 7.48623C7.47728 7.38572 7.73736 7.33398 8 7.33398C8.53043 7.33398 9.03914 7.5447 9.41421 7.91977C9.78929 8.29484 10 8.80355 10 9.33398C10 9.86442 9.78929 10.3731 9.41421 10.7482C9.03914 11.1233 8.53043 11.334 8 11.334Z",
    stroke: "#4D5559",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgOpenEye as ReactComponent };